import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';

import { ROUTES } from './sidebar-routes.config';
import { Router } from '@angular/router';
import { customAnimations } from '../animations/custom-animations';
import { ConfigService } from '../services/config.service';
import { LayoutService } from '../services/layout.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  animations: customAnimations,
})
export class SidebarComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('toggleIcon', { static: false }) toggleIcon: ElementRef;
  public menuItems: any[];
  depth: number;
  activeTitle: string;
  activeTitles: string[] = [];
  expanded: boolean;
  navCollapsedOpen = false;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  layoutSub: Subscription;

  constructor(
    private _renderer: Renderer2,
    private _router: Router,
    public _translate: TranslateService,
    private _configService: ConfigService,
    private _layoutService: LayoutService,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
      this.expanded = true;
    }

    this.layoutSub = this._layoutService.customizerChangeEmitted$.subscribe(
      (options) => {
        if (options) {
          if (options.bgColor) {
            if (options.bgColor === 'white') {
              this.logoUrl = 'assets/img/logo-dark.png';
            } else {
              this.logoUrl = 'assets/img/logo.png';
            }
          }

          if (options.compactMenu === true) {
            this.expanded = false;
            this._renderer.addClass(
              this.toggleIcon.nativeElement,
              'ft-toggle-left',
            );
            this._renderer.removeClass(
              this.toggleIcon.nativeElement,
              'ft-toggle-right',
            );
            this.navCollapsedOpen = true;
          } else if (options.compactMenu === false) {
            this.expanded = true;
            this._renderer.removeClass(
              this.toggleIcon.nativeElement,
              'ft-toggle-left',
            );
            this._renderer.addClass(
              this.toggleIcon.nativeElement,
              'ft-toggle-right',
            );
            this.navCollapsedOpen = false;
          }
        }
      },
    );
  }

  ngOnInit(): void {
    this.config = this._configService.templateConf;
    this.menuItems = ROUTES;

    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }
  }

  ngAfterViewInit(): void {
    setTimeout((): void => {
      if (this.config.layout.sidebar.collapsed !== undefined) {
        if (this.config.layout.sidebar.collapsed === true) {
          this.expanded = false;
          this._renderer.addClass(
            this.toggleIcon.nativeElement,
            'ft-toggle-left',
          );
          this._renderer.removeClass(
            this.toggleIcon.nativeElement,
            'ft-toggle-right',
          );
          this.navCollapsedOpen = true;
        } else if (this.config.layout.sidebar.collapsed === false) {
          this.expanded = true;
          this._renderer.removeClass(
            this.toggleIcon.nativeElement,
            'ft-toggle-left',
          );
          this._renderer.addClass(
            this.toggleIcon.nativeElement,
            'ft-toggle-right',
          );
          this.navCollapsedOpen = false;
        }
      }
    }, 0);
  }

  ngOnDestroy(): void {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
  }

  toggleSlideInOut(): void {
    this.expanded = !this.expanded;
  }

  handleToggle(titles): void {
    this.activeTitles = titles;
  }

  // NGX Wizard - skip url change
  ngxWizardFunction(path: string): void {
    if (path.indexOf('forms/ngx') !== -1) {
      this._router.navigate(['forms/ngx/wizard'], {
        skipLocationChange: false,
      });
    }
  }
}
